export default __webpack_public_path__ + "static/media/upcoming-webinar.d934a73f.svg";